import { useEffect, useState } from "react";
import "./style.css";

const NAMES = [
  "Hana",
  "Dede",
  "Dhika",
  "Budi",
  "Rafly",
  "Rizky",
  "Fikri",
  "Zikri",
  "Fahdi",
  "Siti",
  "Eko",
  "Andi",
  "Dewi",
  "Anggi",
  "Agus",
  "Putri",
  "Joko",
  "Fitri",
  "Dian",
  "Dwi",
  "Nur",
  "Dewi",
  "Tri",
  "Sri",
  "Putri",
  "Eka",
  "Sari",
  "Ayu",
  "Wahyu",
  "Ika",
  "Fitri",
  "Ratna",
  "Andi",
  "Agung",
  "Ahmad",
  "Kurniawan",
  "Ilham",
  "Budi",
  "Adi",
  "Nurul",
  "Putra",
  "Ani",
  "Arif",
  "Puspita",
  "Ari",
  "Indra",
  "Dyah",
  "Rizki",
  "Maria",
  "Ratih",
  "Pratiwi",
  "Kartika",
  "Wulandari",
  "Fajar",
  "Bayu",
  "Lestari",
  "Anita",
  "Muhamad",
  "Kusuma",
  "Rahmawati",
  "Fitria",
  "Retno",
  "Kurnia",
  "Novita",
  "Aditya",
  "Ria",
  "Nugroho",
  "Handayani",
  "Rahayu",
  "Yunita",
  "Rina",
  "Ade",
  "Widya",
  "Intan",
  "Diah",
  "Agustina",
  "Abdul",
  "Setiawan",
  "Rini",
  "Wahyuni",
  "Yulia",
  "Maya",
  "Puji",
  "Utami",
  "Amalia",
  "Dina",
  "Devi",
  "Citra",
  "Arief",
  "Munaroh",
  "Bagus",
  "Hidayat",
  "Hendra",
  "Eva",
  "Endah",
  "Indah",
  "Raden",
  "Novi",
  "Irma",
  "Astuti",
  "Achmad",
  "Aulia",
  "Surya",
  "Amelia",
  "Angga",
  "Hadi",
  "Diana",
  "Anggraini",
  "Wulan",
  "Saputra",
  "Yuni",
  "Agung",
  "Mulyadi",
  "Azzahra",
  "Nadia",
];

const PRODUCT_NEW = [
  // Muncul lebih sering tapi minimal 1x setelahnya
  { name: "Cloud Hosting Micro", weight: 15 },
  { name: "Cloud Hosting Starter", weight: 15 },
  { name: "Cloud Hosting Lite", weight: 15 },
  { name: "Cloud Hosting SOHO", weight: 15 },

  // Muncul tapi tidak sesering + Velocity nya
  { name: "Cloud Hosting Proxima 1", weight: 8 },
  { name: "Cloud Hosting Proxima 1 + Velocity", weight: 8 },
  { name: "Cloud Hosting Proxima 2", weight: 8 },
  { name: "Cloud Hosting Proxima 2 + Velocity", weight: 8 },
  { name: "Cloud Hosting Proxima 3", weight: 8 },
  { name: "Cloud Hosting Proxima 3 + Velocity", weight: 8 },
  { name: "Cloud Hosting Proxima 4", weight: 8 },
  { name: "Cloud Hosting Proxima 4 + Velocity", weight: 8 },

  // Lebih jarang muncul
  { name: "Cloud Hosting Core 1", weight: 3 },
  { name: "Cloud Hosting Core 1 + Velocity", weight: 3 },
  { name: "Cloud Hosting Core 2", weight: 3 },
  { name: "Cloud Hosting Core 2 + Velocity", weight: 3 },
  { name: "Cloud Hosting Core 3", weight: 3 },
  { name: "Cloud Hosting Core 3 + Velocity", weight: 3 },
  { name: "Cloud Hosting Core 4", weight: 3 },
  { name: "Cloud Hosting Core 4 + Velocity", weight: 3 },
];

const DOMAINS = [
  "com",
  "co.id",
  "id",
  "net",
  "org",
  "info",
  "my.id",
  "web.id",
  "biz.id",
  "or.id",
  "ac.id",
  "sch.id",
  "go.id",
  "ponpes.id",
];

const HOSTING_DURATIONS = [
  { duration: "1 Bulan", weight: 15 },
  { duration: "3 Bulan", weight: 15 },
  { duration: "6 Bulan", weight: 15 },
  { duration: "1 Tahun", weight: 15 },
  { duration: "2 Tahun", weight: 2 },
];
const DOMAIN_DURATIONS = [
  { duration: "1 Tahun", weight: 10 },
  { duration: "2 Tahun", weight: 3 },
  { duration: "3 Tahun", weight: 2 },
];

const TIMES = [
  { label: "1 menit lalu", value: 1 },
  { label: "2 menit lalu", value: 2 },
  { label: "3 menit lalu", value: 3 },
  { label: "4 menit lalu", value: 4 },
  { label: "5 menit lalu", value: 5 },
  { label: "6 menit lalu", value: 6 },
  { label: "7 menit lalu", value: 7 },
  { label: "8 menit lalu", value: 8 },
  { label: "9 menit lalu", value: 9 },
  { label: "10 menit lalu", value: 10 },
  { label: "11 menit lalu", value: 11 },
  { label: "12 menit lalu", value: 12 },
  { label: "13 menit lalu", value: 13 },
  { label: "14 menit lalu", value: 14 },
  { label: "15 menit lalu", value: 15 },
  { label: "16 menit lalu", value: 16 },
  { label: "17 menit lalu", value: 17 },
  { label: "18 menit lalu", value: 18 },
  { label: "19 menit lalu", value: 19 },
  { label: "20 menit lalu", value: 20 },
  { label: "30 menit lalu", value: 30 },
  { label: "1 jam lalu", value: 60 },
];

const ICON_HOSTING =
  "https://qwords.com/wp-content/themes/qwords/assets/images/icons/menu/cloud%20hosting/High%20Performance%20Bisnis.webp";
const ICON_DOMAIN =
  "https://qwords.com/wp-content/themes/qwords/assets/images/icons/menu/domain/06-Domain_Tools.webp";

const RATINGS = [
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjXd_FAvbD4JIKRzMB5Gei_ubaY9JMsf1IADaJk4fyJZ6pC1tjoNvg=w90-h90-p-rp-mo-ba6-br100",
    name: "bowoid",
    link: "https://maps.app.goo.gl/tAQveFSvdnxL76o26",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Woohoo!! Thanks Qwords sejauh ini tidak ada problem krusial ketika menggunakan layanan Qwords terutama saya sebagai pengguna VPS yang cukup lama di provider ini hampir tidak ada downtime dan kendala yang berarti."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocLz0k1gNgeqjBj9TgcdhrzngOFG7UmB5e6NWSHzpRdO2hVZoQ=w45-h45-p-rp-mo-br100",
    name: "Federico Esrevatem",
    link: "https://maps.app.goo.gl/j7xiNpmR7r8ZMpEb6",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Ini review jujur dari hati saya: Pelayanan Qwords tuh keren banget, gak pernah mengecewakan Setiap kali butuh bantuan, tim Qwords selalu siap dengan solusi cepat dan tepat. Produk yang mereka tawarkan ..."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUj79leFwUxHEZZbpOJrsrTCKP7yBnR-RRZEQGLh993qpT1YrfT=w90-h90-p-rp-mo-br100",
    name: "Fajar Wijayanto",
    link: "https://maps.app.goo.gl/q5yUfSqEv3oZJeiS7",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Layanan hosting populer, untuk yang membutuhkan beragam paket hosting, sesuai dengan situs web Anda juga dioptimalkan dengan WordPress Hosting, harga yang murah, juga banyak promo setiap hari ..."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUMYmuieZr9JeTL0bqYiAsg4XXfB0oYLxnQYiUmPu9U3ILlJ_7N=w45-h45-p-rp-mo-ba4-br100",
    name: "Bintang SOEPOETRO",
    link: "https://maps.app.goo.gl/gHmBLydqVnBmeSAv8",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Langganan sejak 2010. Baik Dedicated server dan domain+hosting. Terima kasih supportnya, selalu membantu."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUubN6H7eeef4Uleq84DAbM2yaFuINZLbn2Nyy_XsaMmesNSoU=w45-h45-p-rp-mo-ba2-br100",
    name: "Afzon Dakka",
    link: "https://maps.app.goo.gl/4zJF6Vx4yxXFYnnm7",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Pelayanan okay. Baik online maupun offline. Sejauh jadi Pelanggan Qwords, ketika bingung  tentang hal-hal teknis, saya datang ke kantor, dan dibimbing hingga bisa. Recommended hosting ..."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUSNYF3tgfRYLLZDp24WerYK59-_lEKdZNGZroiDzOZlndZ7t4=w45-h45-p-rp-mo-ba3-br100",
    name: "Gito Harzad",
    link: "https://maps.app.goo.gl/JiBogkoCm9RmZD6R6",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Selama ini tidak ada masalah dalam menggunakan nya,past respon juga,cepat tanggap,the best pokok nya,sangat membantuku yang membutuhkan."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjWD6tH2nWvgOZ-3bz2PGmgASGw70WA6VTnrfN0umofmPXFgsGLy=w45-h45-p-rp-mo-br100",
    name: "Muh Tafiqurrahman",
    link: "https://maps.app.goo.gl/LxV8JjxydqcK8zyG7",
    time: "",
    badge: "NEW",
    stars: 5,
    text: "Cloud hosting terbaik diindonesia, semoga terus berkembang, dan menjadi yan terbaik."
  },
  {
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUfuAKKHYnTIu4sJJzTabe_eSxC2zAtGs-rO4Z304Ra3MgwX9ht=w90-h90-p-rp-mo-br100",
    name: "Bagus Ardiansyah",
    link: "https://maps.app.goo.gl/JxBx6c4W6jw6gZ5c8",
    time: "",
    badge: null,
    stars: 5,
    text: "promotion murah. Selama ini tidak ada masalah dalam menggunakan layanan nya. Client assistance nya juga memuaskan, cepat dalam membalas."
  },
];

// Pilihan tipe pembelian: produk saja, domain saja, atau keduanya
const PURCHASE_TYPES = ["product", "domain", "both"];

// Fungsi untuk menentukan purchase type berdasarkan durasi hosting
function getPurchaseTypeBasedOnDuration(hostingDuration) {
  // Jika durasi hosting 1 tahun, lebih sering muncul kombinasi hosting + domain
  if (hostingDuration === "1 Tahun") {
    const weightedTypes = [
      { type: "product", weight: 3 },
      { type: "domain", weight: 1 },
      { type: "both", weight: 8 }  // 8/12 = 67% chance untuk both
    ];
    return getRandomWithWeightGeneric(weightedTypes, 'type');
  } else {
    // Untuk durasi lain, lebih sering muncul product saja
    const weightedTypes = [
      { type: "product", weight: 8 },
      { type: "domain", weight: 2 },
      { type: "both", weight: 3 }  // 3/13 = 23% chance untuk both
    ];
    return getRandomWithWeightGeneric(weightedTypes, 'type');
  }
}

// const CONGRATS_TEXTS = ["Wow!", "Antusias!", "Keren!"];

function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function getRandomDelay(min = 10000, max = 30000) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function truncateText(text, maxLength = 120) {
  if (text.length <= maxLength) return text;
  const truncated = text.substr(0, maxLength);
  return truncated.substr(0, truncated.lastIndexOf(" ")) + " ...";
}

function getRandomWithWeight(items) {
  const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
  let random = Math.random() * totalWeight;

  for (const item of items) {
    if (random < item.weight) {
      return item.duration;
    }
    random -= item.weight;
  }

  return items[0].duration;
}

function getRandomWithWeightGeneric(items, property) {
  const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
  let random = Math.random() * totalWeight;

  for (const item of items) {
    if (random < item.weight) {
      return item[property];
    }
    random -= item.weight;
  }

  return items[0][property];
}

const ModalRating = ({ data, show, isMobile, onClose, isClosing }) => {
  if (!show) return null;
  return (
    <div className={`modal-rating ${isMobile ? 'mobile' : 'desktop'} ${isClosing ? 'closing' : ''}`}>
      <button className="close-btn" onClick={onClose} aria-label="Tutup">×</button>
      <div className="rating-header">
        <div className="rating-user">
          <div className="modal-label mb-2">Ulasan</div>
          <div className="d-flex align-items-center mb-2">
            <img
              src={data.avatar}
              alt="User"
              className="rating-avatar"
            />
            <div>
              <a
                href={data.link}
                className="rating-name"
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.name}
              </a>
            </div>
          </div>
        </div>
        <div className="rating-info">
          <br />
          <span className="rating-stars">{"★★★★★".slice(0, data.stars)}</span>
          <span className="rating-time">{data.time}</span>
          {data.badge && (
            <span className="rating-badge">
              {data.badge}
            </span>
          )}
        </div>
      </div>
      <div className="rating-text">
        {truncateText(data.text, 120)}
      </div>
      <div className="rating-verified">Diverifikasi oleh Google</div>
    </div>
  );
};

const ModalRandomBuy = () => {
  const [show, setShow] = useState(false);
  const [showRating, setShowRating] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isRatingClosing, setIsRatingClosing] = useState(false);
  const [randomData, setRandomData] = useState({});
  const [randomRating, setRandomRating] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [usedReviews, setUsedReviews] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);

  // Fungsi untuk mendapatkan review yang belum digunakan
  const getUnusedReview = () => {
    const availableReviews = RATINGS.filter((_, index) => !usedReviews.includes(index));

    // Jika semua review sudah digunakan, reset dan mulai dari awal
    if (availableReviews.length === 0) {
      setUsedReviews([]);
      const randomIndex = Math.floor(Math.random() * RATINGS.length);
      setUsedReviews([randomIndex]);
      return RATINGS[randomIndex];
    }

    // Pilih review yang belum digunakan
    const randomIndex = Math.floor(Math.random() * availableReviews.length);
    const selectedReview = availableReviews[randomIndex];
    const originalIndex = RATINGS.indexOf(selectedReview);

    // Tambahkan index ke daftar yang sudah digunakan
    setUsedReviews(prev => [...prev, originalIndex]);

    return selectedReview;
  };

  // Fungsi untuk menutup modal dengan animasi smooth
  const closeModal = (isRatingModal = false) => {
    // Clear the auto-hide timeout when manually closing
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }

    if (isRatingModal) {
      setIsRatingClosing(true);
      setTimeout(() => {
        setShowRating(false);
        setIsRatingClosing(false);
      }, 300); // Sesuaikan dengan durasi animasi CSS
    } else {
      setIsClosing(true);
      setTimeout(() => {
        setShow(false);
        setIsClosing(false);
      }, 300); // Sesuaikan dengan durasi animasi CSS
    }
  };

  // Fungsi untuk menampilkan modal baru
  const showNewModal = () => {
    // Pastikan tidak ada modal yang sedang ditampilkan atau sedang dalam proses closing
    if (show || showRating || isClosing || isRatingClosing) return;

    const isRating = Math.random() < 0.25; // 25% chance untuk review, 75% untuk pembelian produk

    if (isRating) {
      setRandomRating(getUnusedReview());
      setShowRating(true);
    } else {
      const data = {
        name: getRandom(NAMES),
        time: getRandom(TIMES).label,
        product: null,
        productDuration: null,
        domain: null,
        domainDuration: null,
        icon: null,
      };

      // Tentukan produk dan durasi hosting dulu
      const hostingProduct = getRandomWithWeightGeneric(PRODUCT_NEW, 'name');
      const hostingDuration = getRandomWithWeightGeneric(HOSTING_DURATIONS, 'duration');

      // Berdasarkan durasi hosting, tentukan purchase type
      const purchaseType = getPurchaseTypeBasedOnDuration(hostingDuration);

      if (purchaseType === "product" || purchaseType === "both") {
        data.product = hostingProduct;
        data.productDuration = hostingDuration;
        data.icon = ICON_HOSTING;
      }
      if (purchaseType === "domain" || purchaseType === "both") {
        data.domain = getRandom(DOMAINS);
        data.domainDuration = getRandomWithWeightGeneric(DOMAIN_DURATIONS, 'duration');
        if (!data.icon) data.icon = ICON_DOMAIN;
      }
      setRandomData(data);
      setShow(true);
    }

    // Set timeout untuk menutup modal otomatis setelah 5 detik
    const hideTimeout = setTimeout(() => {
      if (isRating) {
        setIsRatingClosing(true);
        setTimeout(() => {
          setShowRating(false);
          setIsRatingClosing(false);
        }, 300);
      } else {
        setIsClosing(true);
        setTimeout(() => {
          setShow(false);
          setIsClosing(false);
        }, 300);
      }
      setTimeoutId(null);
    }, 5000);

    setTimeoutId(hideTimeout);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let showTimeout;

    const scheduleNextModal = () => {
      // Schedule next modal after random delay
      showTimeout = setTimeout(() => {
        showNewModal();
      }, getRandomDelay());
    };

    // Start first modal after random delay
    scheduleNextModal();

    return () => {
      if (showTimeout) clearTimeout(showTimeout);
    };
  }, []); // Only run once on mount

  // Separate useEffect to handle modal state changes
  useEffect(() => {
    // When both modals are closed, schedule the next one
    if (!show && !showRating && !isClosing && !isRatingClosing) {
      const showTimeout = setTimeout(() => {
        showNewModal();
      }, getRandomDelay());

      return () => {
        clearTimeout(showTimeout);
      };
    }
  }, [show, showRating, isClosing, isRatingClosing]);

  // DEBUG: tombol manual
  const handleDebugShowRandomBuy = () => {
    // Clear existing timeouts
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const data = {
      name: getRandom(NAMES),
      time: getRandom(TIMES).label,
      product: null,
      productDuration: null,
      domain: null,
      domainDuration: null,
      icon: null,
    };

    // Tentukan produk dan durasi hosting dulu
    const hostingProduct = getRandomWithWeightGeneric(PRODUCT_NEW, 'name');
    const hostingDuration = getRandomWithWeightGeneric(HOSTING_DURATIONS, 'duration');

    // Berdasarkan durasi hosting, tentukan purchase type
    const purchaseType = getPurchaseTypeBasedOnDuration(hostingDuration);

    if (purchaseType === "product" || purchaseType === "both") {
      data.product = hostingProduct;
      data.productDuration = hostingDuration;
      data.icon = ICON_HOSTING;
    }
    if (purchaseType === "domain" || purchaseType === "both") {
      data.domain = getRandom(DOMAINS);
      data.domainDuration = getRandomWithWeightGeneric(DOMAIN_DURATIONS, 'duration');
      if (!data.icon) data.icon = ICON_DOMAIN;
    }
    setRandomData(data);
    setShow(true);
    setShowRating(false);
  };

  const handleDebugShowRating = () => {
    // Clear existing timeouts
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setRandomRating(getUnusedReview());
    setShowRating(true);
    setShow(false);
  };

  return (
    <>
      {show && (
        <div className={`modal-random-buy ${isMobile ? 'mobile' : 'desktop'} ${isClosing ? 'closing' : ''}`}>
          <button className="close-btn" onClick={() => closeModal(false)} aria-label="Tutup">×</button>
          <div className="modal-time text-end d-flex justify-content-between align-items-center">
            <div className="modal-label font-weight-bold"> 
            PRODUK TERJUAL
          </div>
            {randomData.time}
          </div>
          <div className="modal-content">
            
            <div className="modal-name">
              {randomData.name}
              <span className="modal-subtext">
                baru saja membeli
              </span>
            </div>
            {randomData.product && (
              <div className="modal-product">
                <div className="modal-product-line">
                  <span className="modal-product-label">Produk:</span>{" "}
                  <span className="modal-product-value">{randomData.product}</span>
                </div>
                <div className="modal-duration">
                  ({randomData.productDuration})
                </div>
              </div>
            )}
            {randomData.domain && (
              <div className="modal-product modal-product-domain">
                <div className="modal-product-line">
                  <span className="modal-product-label">Domain:</span>{" "}
                  <span className="modal-product-value">{randomData.domain}</span>{" "}
                  <span className="modal-duration modal-duration-inline">
                    ({randomData.domainDuration})
                  </span>
                </div>
              </div>
            )}
            <div className="modal-verified">
              Diverifikasi oleh Xendit
            </div>
          </div>
          <div className="modal-icon">
            <img
              src={randomData.icon}
              alt="icon"
            />
          </div>
        </div>
      )}
      <ModalRating
        data={randomRating}
        show={showRating}
        isMobile={isMobile}
        onClose={() => closeModal(true)}
        isClosing={isRatingClosing}
      />
      {/* Tombol debug di bawah modal */}
      {/* <div className="mt-4 d-flex gap-2">
        <button type="button" className="btn btn-outline-secondary" onClick={handleDebugShowRandomBuy}>
          Show ModalRandomBuy
        </button>
        <button type="button" className="btn btn-outline-secondary" onClick={handleDebugShowRating}>
          Show ModalRating
        </button>
      </div> */}
    </>
  );
};

export default ModalRandomBuy;
